import {
    FaReact, FaGit, FaHtml5, FaCss3Alt, FaJsSquare, FaPython, FaBootstrap, FaAws, FaServer
} from 'react-icons/fa';
import {
    SiTailwindcss, SiDjango, SiPlaywright, SiStripe, SiExpo, SiOpenai, SiAstro
} from 'react-icons/si';

export const technologies = {
    frontend: {
        title: 'Frontend',
        items: [
            { name: 'HTML5', icon: FaHtml5, color: '#E34F26' },
            { name: 'CSS3', icon: FaCss3Alt, color: '#1572B6' },
            { name: 'JavaScript', icon: FaJsSquare, color: '#F7DF1E' },
            { name: 'React', icon: FaReact, color: '#61DAFB' },
            { name: 'Astro', icon: SiAstro, color: '#FF5D01' },
            { name: 'Tailwind CSS', icon: SiTailwindcss, color: '#06B6D4' },
            { name: 'Bootstrap', icon: FaBootstrap, color: '#7952B3' },
        ],
    },
    backend: {
        title: 'Backend',
        items: [
            { name: 'Python', icon: FaPython, color: '#3776AB' },
            { name: 'Django', icon: SiDjango, color: '#092E20' },
            { name: 'Django REST', icon: SiDjango, color: '#A30000' },
        ],
    },
    tools: {
        title: 'Other Tools',
        items: [
            { name: 'Git', icon: FaGit, color: '#F05032' },
            { name: 'Expo', icon: SiExpo, color: '#000020' },
            { name: 'AWS', icon: FaAws, color: '#FF9900' },
            { name: 'Playwright', icon: SiPlaywright, color: '#2EAD33' },
            { name: 'Stripe', icon: SiStripe, color: '#635BFF' },
            { name: 'REST API', icon: FaServer, color: '#6BA539' },
            { name: 'AI Integration (OpenAI)', icon: SiOpenai, color: '#412991' },
        ],
    },
};
